import { useTranslation } from 'react-i18next'

import { CloseIcon, PlusIcon } from '#/shared/ui/icons'

interface ActiveFilterProps {
  label: string
  value: string
  onRemove?: () => void
}

export function ActiveFilter({ label, value, onRemove }: ActiveFilterProps) {
  const { t } = useTranslation()
  return (
    <div className="flex h-8 items-center gap-2.5 rounded-md border border-dashed border-gray-500 px-2 py-1 animate-pop-in">
      <span className="text-sm">
        <span className="text-gray-500">{label}</span>{' '}
        <span className="text-gray-900">{value}</span>
      </span>
      <button
        type="button"
        onClick={onRemove}
        aria-label={t('toolbar.removeFilter', { label })}
        className="flex size-3.5 cursor-pointer items-center justify-center text-gray-500 hover:text-gray-900"
      >
        <CloseIcon className="size-3" />
      </button>
    </div>
  )
}

interface AddFilterButtonProps {
  onClick?: () => void
  label?: string
}

export function AddFilterButton({ onClick, label }: AddFilterButtonProps) {
  const { t } = useTranslation()
  return (
    <button
      type="button"
      onClick={onClick}
      className="flex h-8 cursor-pointer items-center gap-1 rounded-md px-2 py-1 text-sm text-gray-500 hover:bg-gray-50"
    >
      <PlusIcon className="size-3" />
      {label ?? t('toolbar.addFilter')}
    </button>
  )
}
